import React, { useState, useEffect } from "react";
import "../Login.css";
import GoogleButton from "../components/GoogleButton/GoogleButton.jsx";
import MicrosoftButton from "../components/MicrosoftButton/MicrosoftButton.jsx";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "../authConfig.js";
import { useSessionExpiration } from "../hooks/useSessionExpiration.js"; // <--- Ton hook
import ToastNotification from "../components/ToastNotification.jsx";
import { useAuth } from "../context/AuthContext.js";

const msalInstance = new PublicClientApplication(msalConfig);
const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

const Login = () => {
  const [loader, setLoader] = useState(false);
  const { toast, setToast } = useAuth();
  const sessionDisplayed = useSessionExpiration();
  const [googleError, setGoogleError] = useState(null);
  const [microsoftError, setMicrosoftError] = useState(null);

  const handleGoogleError = (error) => {
    setGoogleError(error);
    setLoader(false)
  };

  const handleMicrosoftError = (error) => {
    setMicrosoftError(error);
    setLoader(false)
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-header">
          {/* Logo */}
          <div className="logo-container">
            <img src="/niralakka_logo.png" alt="Logo" width="300px" />
          </div>
          <p>Accédez à votre espace personnel</p>
        </div>

        {/* Message d'expiration de session */}
        {/* {sessionDisplayed && (
          <div className="session-expired-message">
            <div className="session-expired-icon">⚠️</div>
            <div className="session-expired-text">
              Votre session a expiré. Veuillez vous reconnecter.
            </div>
          </div>
        )} */}

        {/* Login options */}

        <div className="login-options">
          {loader ? (
            <>
              <div className="loader"></div>
            </>
          ) : (
            <>
              <GoogleOAuthProvider clientId={clientId}>
                <GoogleButton
                  onError={handleGoogleError}
                  setLoader={setLoader}
                />
              </GoogleOAuthProvider>

              <MsalProvider instance={msalInstance}>
                <MicrosoftButton onError={handleMicrosoftError}  setLoader={setLoader}/>
              </MsalProvider>
            </>
          )}
        </div>

        {/* Message d'erreur */}
        {(googleError || microsoftError) && (
          <div className="login-error-message">
            <div className="login-error-icon">⚠️</div>
            <div className="login-error-text">
              {googleError || microsoftError}
            </div>
          </div>
        )}
        <div className="login-footer">
          <p>© Niralakka {new Date().getFullYear()}</p>
        </div>
      </div>

      {toast.visible && (
        <ToastNotification
          type={toast.type}
          message={toast.message}
          onClose={() => setToast({ ...toast, visible: false })}
        />
      )}
    </div>
  );
};

export default Login;
